export const text = {
  button: "Delete",
};
